import { patientDataActions } from '../../../../redux/actions/user/patient/patient_data';

const initialState = {
  isAuthenticated: false,
  patient: null,
  loading: false,
  error: null
};

const patientDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case patientDataActions.FETCH_PATIENT.REQUEST:
    case patientDataActions.UPDATE_PATIENT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null // Reset any previous errors
      };

    case patientDataActions.FETCH_PATIENT.SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        patient: action.payload // Store fetched patient data
      };

    case patientDataActions.UPDATE_PATIENT.SUCCESS:
      return {
        ...state,
        loading: false,
        patient: { ...state.patient, ...action.payload } // Update patient data
      };

    case patientDataActions.FETCH_PATIENT.FAILURE:
    case patientDataActions.UPDATE_PATIENT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error // Capture error message
      };

    case patientDataActions.FETCH_PATIENT.RESET:
    case patientDataActions.UPDATE_PATIENT.RESET:
      return {
        ...state,
        patient: null, // Reset patient data
        error: null, // Reset any errors
        loading: false // Reset loading state
      };

    default:
      return state;
  }
};

export default patientDataReducer;
